import { PageRouteProps } from "../../types";

export const settingRoutes: PageRouteProps[] = [
  {
    pathName: "/admin/settings",
    component: "Settings",
    type: "admin",
    mode: "static",
  },
  {
    pathName: "/admin/setting/modules",
    component: "ModuleList",
    type: "admin",
    mode: "static",
  },
];
